/**
 * Resizes an image File to a JPEG data URL, capped at maxPx on the longest
 * side. Used for user avatar uploads both on the own-profile page and the
 * admin artist-management page.
 *
 * @param {File} file      - Image file selected by the user.
 * @param {number} maxPx   - Maximum width or height in pixels (default 512).
 * @param {number} quality - JPEG quality 0-1 (default 0.85).
 * @returns {Promise<string>} - Resolves to a data:image/jpeg;base64,... URL.
 */
export const resizeImageToDataUrl = (file, maxPx = 512, quality = 0.85) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const objectUrl = URL.createObjectURL(file);
    img.onload = () => {
      URL.revokeObjectURL(objectUrl);
      const ratio = Math.min(maxPx / img.width, maxPx / img.height, 1);
      const canvas = document.createElement('canvas');
      canvas.width = Math.round(img.width * ratio);
      canvas.height = Math.round(img.height * ratio);
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      resolve(canvas.toDataURL('image/jpeg', quality));
    };
    img.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error('Failed to load image'));
    };
    img.src = objectUrl;
  });
};
